import { FC, PropsWithChildren } from 'react';
import { SystemContext } from '@chakra-ui/react';

import { DesignSystemProvider } from '~/core/shared/lib/chakraUi/Provider';
import { logger } from '~/core/shared/utils/logger';

export const Theme: FC<
  PropsWithChildren<{
    theme: SystemContext;
    asPublic?: boolean;
  }>
> = ({ children, theme, asPublic = false }) => {
  logger.log(
    `${asPublic ? 'public' : 'middle-office'} theme loaded with theme`,
    theme,
  );

  return <DesignSystemProvider theme={theme}>{children}</DesignSystemProvider>;
};
